/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ mode: NonNullable<unknown> }} Settings_ThemeInputs */

const en_settings_theme = /** @type {(inputs: Settings_ThemeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Theme — ${i?.mode}`)
};

const he_settings_theme = /** @type {(inputs: Settings_ThemeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ערכת נושא — ${i?.mode}`)
};

/**
* | output |
* | --- |
* | "Theme — {mode}" |
*
* @param {Settings_ThemeInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_theme = /** @type {((inputs: Settings_ThemeInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_ThemeInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_theme(inputs)
	return he_settings_theme(inputs)
});